import { render, staticRenderFns } from "./floor-product.vue?vue&type=template&id=19866d4e&scoped=true"
import script from "./floor-product.vue?vue&type=script&lang=js"
export * from "./floor-product.vue?vue&type=script&lang=js"
import style0 from "./floor-product.vue?vue&type=style&index=0&id=19866d4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19866d4e",
  null
  
)

export default component.exports